module.exports = __webpack_public_path__ + "media/images/default/pages/treatment_features/features/2-9a66ec341b0fc361919046d774381f43.svg";